export { disableScroll, enableScroll } from "./disable.js";
export { lockScroll, unlockScroll } from "./lock.js";
